export default __webpack_public_path__ + "static/media/like_outlined.65863bcb.svg";